// Manual activity estimates, not measured energy expenditure.
// Walking MET: https://pacompendium.com/transportation/ (16060).
// Cadence is an app assumption; subtract resting energy from the MET estimate.
export const activityRules = {
  walkingMet: 3.5,
  restingMet: 1,
  stepsPerMinute: 100,
  maxSteps: 100_000,
  maxWorkoutCalories: 10_000,
  maxWorkoutMinutes: 1_440,
  maxWorkoutDistanceKm: 300,
} as const;

export type WorkoutIntensity = "light" | "moderate" | "vigorous";
export type WorkoutRule = {
  id: string;
  name: string;
  mets: readonly [number, number, number];
  speedsKmh?: readonly [number, number, number];
  stepsPerMinute?: number;
};

// 2024 Adult Compendium of Physical Activities. Each row is an approximate
// light/ordinary/vigorous scenario, not a measurement of one person's effort.
// https://pacompendium.com/adult-compendium/
export const workoutRules: readonly WorkoutRule[] = [
  { id: "walking", name: "Ходьба", mets: [2.8, 3.5, 4.8], speedsKmh: [3.5, 5, 6] },
  { id: "running", name: "Бег", mets: [6.5, 8.5, 11], speedsKmh: [6.5, 8.5, 11], stepsPerMinute: 160 },
  { id: "cycling", name: "Велосипед", mets: [4, 7, 9], speedsKmh: [13, 18, 23] },
  { id: "swimming", name: "Плавание", mets: [5.8, 8, 9.8], speedsKmh: [1.8, 2.7, 3.5] },
  { id: "strength", name: "Силовая тренировка", mets: [3, 3.5, 6] },
  { id: "yoga", name: "Йога", mets: [2, 2.3, 4] },
  { id: "pilates", name: "Пилатес", mets: [1.8, 2.8, 4] },
  { id: "elliptical", name: "Эллипсоид", mets: [3.5, 5, 9] },
  { id: "stationary-bike", name: "Велотренажёр", mets: [3.5, 5.8, 8.8] },
  { id: "rowing", name: "Гребной тренажёр", mets: [3.5, 5, 7.3] },
  { id: "jump-rope", name: "Скакалка", mets: [8, 11, 12.3] },
  { id: "circuit", name: "Круговая тренировка", mets: [3.5, 5, 7.5] },
  { id: "hiit", name: "Интервальная тренировка", mets: [5, 7, 11] },
  { id: "aerobics", name: "Аэробика", mets: [4, 5.5, 7.3] },
  { id: "dancing", name: "Танцы", mets: [3, 5, 7.3] },
  { id: "hiking", name: "Поход", mets: [3.8, 5.3, 7.8], speedsKmh: [3, 4, 5] },
  { id: "soccer", name: "Футбол", mets: [3.5, 7, 9.5] },
  { id: "basketball", name: "Баскетбол", mets: [5, 7.5, 9.3] },
  { id: "tennis", name: "Теннис", mets: [4.5, 6.8, 8] },
  { id: "badminton", name: "Бадминтон", mets: [5.5, 7, 9] },
  { id: "volleyball", name: "Волейбол", mets: [3, 4, 8] },
  { id: "table-tennis", name: "Настольный теннис", mets: [3, 4, 5] },
] as const;
